import { NonEmptyArray } from "ts-essentials"

/* Types */
type NumberDataType = "millions" | "percent" | "numeric"
type SingleNumberOperatorType = "gt" | "gte" | "lt" | "lte" | "eq" | "neq"
type RangeNumberOperatorType = "between" | "notBetween"

/* Formatters */
function singleNumberFormatter(id: string, operator: SingleNumberOperatorType, dataType: NumberDataType, ...values: [string]) {
  let value = parseFloat(values[0])
  if (dataType === "millions") {
    value *= 1000000
  }
  return {
    [operator]: value,
  }
}

function rangeNumberFormatter(id: string, operator: RangeNumberOperatorType, dataType: NumberDataType, ...values: [string, string]) {
  let min = parseFloat(values[0])
  let max = parseFloat(values[1])
  if (dataType === "millions") {
    min *= 1000000
    max *= 1000000
  }
  return {
    [operator]: { min, max },
  }
}

/* Validators */
function singleNumberValidator(values: [string]) {
  return isFinite(parseFloat(values[0]))
}

function rangeNumberValidator(values: [string, string]) {
  return isFinite(parseFloat(values[0])) && isFinite(parseFloat(values[1]))
}

/* Operators */
export interface SingleNumberOperator {
  label: string
  value: SingleNumberOperatorType
  queryFormatter: typeof singleNumberFormatter
  validator: typeof singleNumberValidator
  selectorType?: undefined
}

export interface RangeNumberOperator {
  label: string
  value: RangeNumberOperatorType
  queryFormatter: typeof rangeNumberFormatter
  validator: typeof rangeNumberValidator
  selectorType: "range"
}

export const NUMERIC_OPERATORS: NonEmptyArray<SingleNumberOperator | RangeNumberOperator> = [{
  label: "is greater than",
  value: "gt",
  queryFormatter: singleNumberFormatter,
  validator: singleNumberValidator,
}, {
  label: "is greater than or equal to",
  value: "gte",
  queryFormatter: singleNumberFormatter,
  validator: singleNumberValidator,
}, {
  label: "is less than",
  value: "lt",
  queryFormatter: singleNumberFormatter,
  validator: singleNumberValidator,
}, {
  label: "is less than or equal to",
  value: "lte",
  queryFormatter: singleNumberFormatter,
  validator: singleNumberValidator,
}, {
  label: "equals",
  value: "eq",
  queryFormatter: singleNumberFormatter,
  validator: singleNumberValidator,
}, {
  label: "does not equal",
  value: "neq",
  queryFormatter: singleNumberFormatter,
  validator: singleNumberValidator,
}, {
  label: "is between",
  value: "between",
  queryFormatter: rangeNumberFormatter,
  selectorType: "range",
  validator: rangeNumberValidator,
}, {
  label: "is not between",
  value: "notBetween",
  queryFormatter: rangeNumberFormatter,
  selectorType: "range",
  validator: rangeNumberValidator,
}] as const
